import { render, staticRenderFns } from "./GroupMemberEdit.vue?vue&type=template&id=55877cd8&"
import script from "./GroupMemberEdit.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports